import ApiService from "./ApiService";

export const AuthService = {

    // USER
    login: function (param) {
        return ApiService.postFetch(`account/login`, param);
    },

    register: function (param) {
        return ApiService.postFetch(`account/register`, param);
    },

    getAllUsers: function (param) {
        return ApiService.getFetch(`account/get-all-users`, param);
    },

    deleteUser: function (param) {
        return ApiService.getFetch(`account/delete-user`, param);
    },

    updateUser: function (userId, params) {
        return ApiService.putFetch(`account/update-user?id=${userId}`, params);
    },

    getUserById: function (param) {
        return ApiService.getFetch(`account/get-user-by-id?id=${param}`, param);
    },

    // BRANDS 
    getBrands: function(params) {
        return ApiService.getFetch('brand/get-brands', params);
    },
    createBrand: function(params) {
        console.log("params", params)
        return ApiService.postFetch('brand/create-brand', params);
    },

    deleteBrand: function(params) {
        console.log("params", params)
        return ApiService.deleteFetch('brand/delete-brand', params);
    },

    // PRODUCTS

    getProducts: function(params){
        return ApiService.getFetch('product/get-products', params);
    },
    deleteProduct: function(params){
        return ApiService.deleteFetch('product/delete-product', params);
    },
    getDiscountedProducts: function(params){
        return ApiService.getFetch('product/discounted-products', params);
    },
    getLowStockProducts: function(params){
        return ApiService.getFetch('product/get-products?ShowLowStock=true', params);
    },
    createProduct: function(params){
        return ApiService.postFetch('product/create-product', params);
    },
    getProductDetails: function(barcode){
        return ApiService.getFetch(`product/get-product-details?barcode=${barcode}`, barcode);
    },

    uploadProductsInBulk: function(params){
        return ApiService.postFetch('product/import-products-json', params);
    },

    // STORES
    getStores: function(params) {
        return ApiService.getFetch('store/get-stores', params);
    },
    
    createStore: function(params) {
        return ApiService.postFetch('store/create-store', params);
    },

    deleteStore: function(params) {
        return ApiService.deleteFetch('store/delete-store', params);
    },

    //CATEGORIES

    getCategories: function(params) {
        return ApiService.getFetch('category/get-categories', params);
    },

    createCategory: function(params) {
        return ApiService.postFetch('category/create-category', params);
    },

    deleteCategory: function(categoryId) {
        return ApiService.deleteFetch(`category/delete-category?categoryId=${categoryId}`, categoryId);
    },

    
    //orders
    
    getAllOrders: function(params) {
        return ApiService.getFetch('order/get-orders', params);
    },
    getOrdersByUser: function(userId) {
        return ApiService.getFetch(`order/get-orders-by-user?userId=${userId}`, {});
    },
    getOrderDetails: function(orderId) {
        return ApiService.getFetch(`order/get-order-details?orderId=${orderId}`, {});
    },
    createOrder: function(order, applySale) {
        return ApiService.postFetch(`order/complete-order?applySale=${applySale}`, order);
    },
    changeOrderStatus: function(orderId, params) {
        console.log("params", params)
        return ApiService.putFetch(`order/set-order-status?orderId=${orderId}`, params);
    },



    // Roles
    getAllRoles: function(params) {
        return ApiService.getFetch('UserRole/get-all-roles', params);
    },

    assignRole: function(params) {
        return ApiService.postFetch('UserRole/assign-role', params);
    },

     // Promotions
     getPromotions: function(params) {
        return ApiService.getFetch('promotions/get-promotions', params);
    },
    createPromotion: function(params) {
        return ApiService.postFetch('promotions/add-promotion', params);
    },

    //Stock
    moveStock: function(params) {
        return ApiService.postFetch('stock/move-stock', params);
    },

    createStock: function(params) {
        return ApiService.postFetch('stock/create-stock', params);
    },
    
} 